<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="input-group">
          <div class="d-flex mr-n1">
            <button class="input-group-text bg-orange text-white">
              <em class="fas fa-search pl-2 pr-2" />
            </button>
          </div>
          <input
            v-model="itemMatched"
            class="form-control"
            :placeholder="placeholder"
            type="text"
          />
        </div>
      </div>
    </div>

    <div class="panel overflow-auto border">
      <div class="row mx-1">
        <div
          v-for="item in itemsMatched"
          :key="item.label"
          class="col-12 p-2 bg-primary-1--hover"
          @click="$emit('selected', item)"
        >
          <em v-if="item.icon" class="mr-1" :class="item.icon" />
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Selector',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      itemMatched: '',
    };
  },
  computed: {
    itemsMatched() {
      let filtered = this.items.filter((item) => {
        return item.label.includes(this.itemMatched);
      });
      return this.$deleteArrayObjectDuplicates(filtered, 'label');
    },
  },
  inject: ['placeholder'],
  mounted() {
    this.placeholderSelector = this.placeholder;
  },
};
</script>

<style scoped>
.panel {
  height: 150px !important;
}
</style>
